export default __webpack_public_path__ + "static/media/pw-logo-horizontal-color-dark.9a023beb.svg";